// ============================================
// ARBOL DE HIPOTESIS
// Estructura estatica basada en el Excel de Karlen (Arbol_prompt.md corregido)
// Usado en el selector de hipotesis del tab Analysis & Estudios
// ============================================

export type CategoriaHipotesis = "terreno" | "construccion" | "otros";

export interface NodoHipotesis {
  id: string;
  label: string;
  categoria: CategoriaHipotesis;
  children?: NodoHipotesis[];
  documentosRecomendados?: string[]; // solo en hojas
}

export const ARBOL_HIPOTESIS: NodoHipotesis[] = [
  // ==========================================
  // TERRENO
  // ==========================================
  {
    id: "terreno",
    label: "Terreno",
    categoria: "terreno",
    children: [
      // --- Sobretasa ---
      {
        id: "terreno.sobretasa",
        label: "Sobretasa",
        categoria: "terreno",
        children: [
          {
            id: "terreno.sobretasa.capa_sanitaria",
            label: "Capa sanitaria",
            categoria: "terreno",
            documentosRecomendados: ["Factibilidad Sanitaria (Empresa de agua concesionaria)"],
          },
          {
            id: "terreno.sobretasa.construcciones",
            label: "Construcciones",
            categoria: "terreno",
            children: [
              {
                id: "terreno.sobretasa.construcciones.vigente",
                label: "Vigente",
                categoria: "terreno",
                documentosRecomendados: [
                  "Inicio de obras",
                  "Libro firmado de trazados",
                  "Permiso de edificacion (Municipalidad)",
                  "Fotos satelitales del predio",
                ],
              },
              {
                id: "terreno.sobretasa.construcciones.en_construccion",
                label: "En Construccion",
                categoria: "terreno",
                documentosRecomendados: [
                  "Inicio de obras",
                  "Libro firmado de trazados",
                  "Permiso de edificacion",
                  "Fotos satelitales del predio",
                ],
              },
            ],
          },
          {
            id: "terreno.sobretasa.extension_urbana_rural",
            label: "Extension Urbana / Rural",
            categoria: "terreno",
            documentosRecomendados: ["CIP (que indique extension urbana o rural)"],
          },
          {
            id: "terreno.sobretasa.prohibicion_edificar",
            label: "Prohibicion edificar",
            categoria: "terreno",
            documentosRecomendados: ["Ordenanza IPT", "CIP"],
          },
          {
            id: "terreno.sobretasa.catastrofe",
            label: "Catastrofe",
            categoria: "terreno",
            documentosRecomendados: [],
          },
        ],
      },

      // --- IPT (PRC, PRM) o CIP ---
      {
        id: "terreno.ipt_cip",
        label: "IPT (PRC, PRM) o CIP",
        categoria: "terreno",
        children: [
          {
            id: "terreno.ipt_cip.aup",
            label: "AUP",
            categoria: "terreno",
            children: [
              {
                id: "terreno.ipt_cip.aup.vialidad",
                label: "Vialidad",
                categoria: "terreno",
                children: [
                  {
                    id: "terreno.ipt_cip.aup.vialidad.ensanche",
                    label: "Ensanche",
                    categoria: "terreno",
                    documentosRecomendados: ["CIP", "Aclaratoria AUP"],
                  },
                  {
                    id: "terreno.ipt_cip.aup.vialidad.apertura",
                    label: "Apertura",
                    categoria: "terreno",
                    documentosRecomendados: ["CIP", "Aclaratoria AUP"],
                  },
                ],
              },
              {
                id: "terreno.ipt_cip.aup.area_verde_bnup",
                label: "Area Verde BNUP",
                categoria: "terreno",
                documentosRecomendados: ["CIP", "Aclaratoria AUP"],
              },
            ],
          },
          {
            id: "terreno.ipt_cip.restricciones",
            label: "Restricciones IPT",
            categoria: "terreno",
            children: [
              {
                id: "terreno.ipt_cip.restricciones.prohibicion_edificar",
                label: "Prohibicion de edificar",
                categoria: "terreno",
                children: [
                  {
                    id: "terreno.ipt_cip.restricciones.areas_riesgo",
                    label: "Areas de Riesgo (asimilacion)",
                    categoria: "terreno",
                    children: [
                      {
                        id: "terreno.ipt_cip.restricciones.areas_riesgo.zona_inundable",
                        label: "Zona inundable",
                        categoria: "terreno",
                        documentosRecomendados: ["CIP"],
                      },
                      {
                        id: "terreno.ipt_cip.restricciones.areas_riesgo.quebradas",
                        label: "Quebradas",
                        categoria: "terreno",
                        documentosRecomendados: ["CIP"],
                      },
                    ],
                  },
                  {
                    id: "terreno.ipt_cip.restricciones.zona_proteccion",
                    label: "Zona de proteccion (asimilacion)",
                    categoria: "terreno",
                    children: [
                      {
                        id: "terreno.ipt_cip.restricciones.zona_proteccion.bosque_nativo",
                        label: "Bosque Nativo",
                        categoria: "terreno",
                        documentosRecomendados: ["CIP"],
                      },
                      {
                        id: "terreno.ipt_cip.restricciones.zona_proteccion.lineas_alta_tension",
                        label: "Lineas alta tension",
                        categoria: "terreno",
                        documentosRecomendados: ["CIP"],
                      },
                      {
                        id: "terreno.ipt_cip.restricciones.zona_proteccion.lineas_tren",
                        label: "Lineas de Tren",
                        categoria: "terreno",
                        documentosRecomendados: ["CIP"],
                      },
                      {
                        id: "terreno.ipt_cip.restricciones.zona_proteccion.aeropuertos",
                        label: "Aeropuertos",
                        categoria: "terreno",
                        documentosRecomendados: ["CIP"],
                      },
                      {
                        id: "terreno.ipt_cip.restricciones.zona_proteccion.humedal",
                        label: "Humedal",
                        categoria: "terreno",
                        documentosRecomendados: ["CIP", "Analisis de Precios"],
                      },
                      {
                        id: "terreno.ipt_cip.restricciones.zona_proteccion.otros",
                        label: "Otros (CIP)",
                        categoria: "terreno",
                        documentosRecomendados: ["CIP"],
                      },
                    ],
                  },
                  {
                    id: "terreno.ipt_cip.restricciones.prohibicion_edificar_directa",
                    label: "Prohibicion de edificar",
                    categoria: "terreno",
                    documentosRecomendados: ["CIP"],
                  },
                ],
              },
            ],
          },
        ],
      },

      // --- Superficie ---
      {
        id: "terreno.superficie",
        label: "Superficie",
        categoria: "terreno",
        children: [
          {
            id: "terreno.superficie.diferencia_m2",
            label: "Diferencia superficie m2",
            categoria: "terreno",
            documentosRecomendados: [
              "Dominio Vigente",
              "Permiso de Edificacion",
              "Detalle Catastral",
              "Foto satelital",
            ],
          },
        ],
      },

      // --- Geolocalizacion ---
      {
        id: "terreno.geolocalizacion",
        label: "Geolocalizacion",
        categoria: "terreno",
        children: [
          {
            id: "terreno.geolocalizacion.rol",
            label: "Rol",
            categoria: "terreno",
            documentosRecomendados: [
              "Foto SII",
              "Foto satelital",
              "Plano inscrito en CBR o timbrado por DOM",
            ],
          },
          {
            id: "terreno.geolocalizacion.area_homogenea",
            label: "Area Homogenea",
            categoria: "terreno",
            documentosRecomendados: [
              "Foto SII",
              "Foto satelital",
              "Plano inscrito en CBR o timbrado por DOM",
            ],
          },
        ],
      },

      // --- Correctores ---
      {
        id: "terreno.correctores",
        label: "Correctores",
        categoria: "terreno",
        children: [
          {
            id: "terreno.correctores.csp",
            label: "CSP - Simple progresivo",
            categoria: "terreno",
          },
          {
            id: "terreno.correctores.cmp",
            label: "CMP - Multiple progresivo",
            categoria: "terreno",
          },
          {
            id: "terreno.correctores.frente_fondo",
            label: "Frente y fondo",
            categoria: "terreno",
          },
          {
            id: "terreno.correctores.ce",
            label: "CE - Excepcional",
            categoria: "terreno",
            children: [
              { id: "terreno.correctores.ce.deficiencia_acceso", label: "Deficiencia de acceso", categoria: "terreno" },
              { id: "terreno.correctores.ce.servidumbre_paso", label: "Servidumbre de paso", categoria: "terreno" },
              { id: "terreno.correctores.ce.equipamiento_subterraneo_bnup", label: "Equipamiento subterraneo BNUP", categoria: "terreno" },
              { id: "terreno.correctores.ce.prohibicion_edificar", label: "Prohibicion de edificar", categoria: "terreno" },
              {
                id: "terreno.correctores.ce.predio_habitacional",
                label: "Predio destino principal habitacional",
                categoria: "terreno",
                children: [
                  { id: "terreno.correctores.ce.predio_habitacional.basural", label: "Colindante basural", categoria: "terreno" },
                  { id: "terreno.correctores.ce.predio_habitacional.cementerio", label: "Colindante cementerio", categoria: "terreno" },
                  { id: "terreno.correctores.ce.predio_habitacional.carcel", label: "Colindante carcel", categoria: "terreno" },
                  { id: "terreno.correctores.ce.predio_habitacional.estadio", label: "Colindante estadio futbol", categoria: "terreno" },
                  { id: "terreno.correctores.ce.predio_habitacional.propiedad_abandonada", label: "Colindante propiedad abandonada", categoria: "terreno" },
                ],
              },
              {
                id: "terreno.correctores.ce.superficie_no_centralizada",
                label: "Superficie no centralizada",
                categoria: "terreno",
                children: [
                  { id: "terreno.correctores.ce.superficie_no_centralizada.saldo_predial", label: "Saldo predial", categoria: "terreno" },
                  { id: "terreno.correctores.ce.superficie_no_centralizada.macrolote", label: "Macrolote", categoria: "terreno" },
                ],
              },
              {
                id: "terreno.correctores.ce.area_verde",
                label: "Area verde",
                categoria: "terreno",
                children: [
                  { id: "terreno.correctores.ce.area_verde.bnup", label: "B.N.U.P.", categoria: "terreno" },
                  { id: "terreno.correctores.ce.area_verde.no_bnup", label: "No B.N.U.P.", categoria: "terreno" },
                ],
              },
              { id: "terreno.correctores.ce.nuevas_obras_urbanizacion", label: "Nuevas obras de urbanizacion", categoria: "terreno" },
              { id: "terreno.correctores.ce.concesion_maritima", label: "Concesion maritima, sector playa", categoria: "terreno" },
              { id: "terreno.correctores.ce.siniestro_catastrofe", label: "Predio afecto a siniestro o catastrofe", categoria: "terreno" },
            ],
          },
          {
            id: "terreno.correctores.ca",
            label: "CA - Altura",
            categoria: "terreno",
          },
          {
            id: "terreno.correctores.otras_circulares",
            label: "Otras circulares (Jota)",
            categoria: "terreno",
          },
        ],
      },

      // --- Area Homogenea ---
      {
        id: "terreno.area_homogenea",
        label: "Area Homogenea",
        categoria: "terreno",
        children: [
          {
            id: "terreno.area_homogenea.vut",
            label: "VUT",
            categoria: "terreno",
            children: [
              {
                id: "terreno.area_homogenea.vut.comparacion_ah",
                label: "Comparacion entre AH",
                categoria: "terreno",
                children: [
                  {
                    id: "terreno.area_homogenea.vut.comparacion_ah.colindantes",
                    label: "Colindantes",
                    categoria: "terreno",
                    children: [
                      { id: "terreno.area_homogenea.vut.comparacion_ah.colindantes.uso_suelo", label: "Uso de suelo", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                      { id: "terreno.area_homogenea.vut.comparacion_ah.colindantes.categoria_constructiva", label: "Categoria constructiva", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                      { id: "terreno.area_homogenea.vut.comparacion_ah.colindantes.nivel_densificacion", label: "Nivel densificacion", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                      { id: "terreno.area_homogenea.vut.comparacion_ah.colindantes.elementos_urbanos", label: "Elementos y sectores urbanos", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                      { id: "terreno.area_homogenea.vut.comparacion_ah.colindantes.destino_ah", label: "Destino AH (mixto, h, c)", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                    ],
                  },
                  {
                    id: "terreno.area_homogenea.vut.comparacion_ah.similares",
                    label: "Similares",
                    categoria: "terreno",
                    children: [
                      { id: "terreno.area_homogenea.vut.comparacion_ah.similares.uso_suelo", label: "Uso de suelo", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                      { id: "terreno.area_homogenea.vut.comparacion_ah.similares.categoria_constructiva", label: "Categoria constructiva", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                      { id: "terreno.area_homogenea.vut.comparacion_ah.similares.nivel_densificacion", label: "Nivel densificacion", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                      { id: "terreno.area_homogenea.vut.comparacion_ah.similares.elementos_urbanos", label: "Elementos y sectores urbanos", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                      { id: "terreno.area_homogenea.vut.comparacion_ah.similares.destino_ah", label: "Destino AH (mixto, h, c)", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                    ],
                  },
                ],
              },
              {
                id: "terreno.area_homogenea.vut.compraventas",
                label: "Compraventas",
                categoria: "terreno",
                children: [
                  { id: "terreno.area_homogenea.vut.compraventas.ah_vs_propias", label: "AH vs compraventas propias", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                  { id: "terreno.area_homogenea.vut.compraventas.ah_vs_colindantes_similares", label: "AH vs colindantes o similares", categoria: "terreno", documentosRecomendados: ["Analisis de Precios"] },
                ],
              },
            ],
          },
          {
            id: "terreno.area_homogenea.rango_superficie",
            label: "Rango de superficie",
            categoria: "terreno",
            children: [
              {
                id: "terreno.area_homogenea.rango_superficie.compraventas",
                label: "Compraventas",
                categoria: "terreno",
                children: [
                  { id: "terreno.area_homogenea.rango_superficie.compraventas.ah_vs_propias", label: "AH vs compraventas propias", categoria: "terreno", documentosRecomendados: ["Analisis de elementos cualitativos"] },
                  { id: "terreno.area_homogenea.rango_superficie.compraventas.ah_vs_colindantes_similares", label: "AH vs colindantes o similares", categoria: "terreno", documentosRecomendados: ["Analisis de elementos cualitativos"] },
                ],
              },
            ],
          },
        ],
      },
    ],
  },

  // ==========================================
  // CONSTRUCCION
  // ==========================================
  {
    id: "construccion",
    label: "Construccion",
    categoria: "construccion",
    children: [
      {
        id: "construccion.ipt_cip",
        label: "IPT (PRC, PRM) o CIP",
        categoria: "construccion",
        children: [
          {
            id: "construccion.ipt_cip.aup",
            label: "AUP",
            categoria: "construccion",
            children: [
              {
                id: "construccion.ipt_cip.aup.vialidad",
                label: "Vialidad",
                categoria: "construccion",
                children: [
                  { id: "construccion.ipt_cip.aup.vialidad.ensanche", label: "Ensanche", categoria: "construccion" },
                  { id: "construccion.ipt_cip.aup.vialidad.apertura", label: "Apertura", categoria: "construccion" },
                ],
              },
              {
                id: "construccion.ipt_cip.aup.area_verde_bnup",
                label: "Area Verde BNUP",
                categoria: "construccion",
              },
            ],
          },
        ],
      },
      {
        id: "construccion.clasificacion",
        label: "Clasificacion",
        categoria: "construccion",
        children: [
          { id: "construccion.clasificacion.clase", label: "Clase", categoria: "construccion" },
          { id: "construccion.clasificacion.calidad", label: "Calidad", categoria: "construccion" },
        ],
      },
      {
        id: "construccion.superficie",
        label: "Superficie",
        categoria: "construccion",
        children: [
          { id: "construccion.superficie.exceso_tasacion", label: "Exceso tasacion", categoria: "construccion" },
          { id: "construccion.superficie.omision_tasacion", label: "Omision tasacion", categoria: "construccion" },
          { id: "construccion.superficie.error_baja_tasacion", label: "Error a la baja tasacion", categoria: "construccion" },
        ],
      },
      {
        id: "construccion.depreciacion",
        label: "Depreciacion",
        categoria: "construccion",
      },
    ],
  },

  // ==========================================
  // OTROS
  // ==========================================
  {
    id: "otros",
    label: "Otros",
    categoria: "otros",
    children: [
      {
        id: "otros.exenciones",
        label: "Exenciones",
        categoria: "otros",
      },
      {
        id: "otros.aup",
        label: "AUP",
        categoria: "otros",
      },
    ],
  },
];

// ============================================
// HELPERS
// ============================================

export function findNodoById(
  id: string,
  nodes: NodoHipotesis[] = ARBOL_HIPOTESIS
): NodoHipotesis | undefined {
  for (const node of nodes) {
    if (node.id === id) return node;
    if (node.children) {
      const found = findNodoById(id, node.children);
      if (found) return found;
    }
  }
  return undefined;
}

export function getLeafNodes(
  nodes: NodoHipotesis[] = ARBOL_HIPOTESIS
): NodoHipotesis[] {
  const leaves: NodoHipotesis[] = [];
  for (const node of nodes) {
    if (!node.children || node.children.length === 0) {
      leaves.push(node);
    } else {
      leaves.push(...getLeafNodes(node.children));
    }
  }
  return leaves;
}

export function getDocumentosRecomendados(
  hipotesisIds: string[]
): string[] {
  const docs = new Set<string>();
  for (const id of hipotesisIds) {
    const nodo = findNodoById(id);
    if (nodo?.documentosRecomendados) {
      nodo.documentosRecomendados.forEach((d) => docs.add(d));
    }
  }
  return Array.from(docs);
}
